import { Pipe, PipeTransform } from '@angular/core';
import { HotelSearchedRoomRate } from '@hotels/hotel-results/entities/hotel-searched';

@Pipe({
  name: 'totalAmount',
  standalone: false
})
export class TotalAmountPipe implements PipeTransform {

  transform(room: HotelSearchedRoomRate): number {
    return room.Price.Amount + room.Price.Fees + room.Price.Taxes + room.Price.Surcharges;
  }

}
